import { decodeHtml } from '@/shared/helpers/decode';

/**
 * Receives a string(HTML tags included) and it truncates them at specified length or first line break
 * @param input - String to be truncated
 * @param length - A number to return a specific length
 * @param ellipsisType - Renders ellipsis as plaintext (default is false)
 * @returns {string} Returns the string passed truncated
 */
export const truncate = (
  input: string,
  length: number,
  ellipsisType: 'plain' | 'char' = 'char',
): string => {
  const decoded = decodeHtml(input ?? '');
  const ellipsis = ellipsisType === 'plain' ? '...' : '&hellip;';

  if (decoded.includes('<br />')) {
    return (
      decoded.length > length
        ? `${decoded.substring(0, length - 1)}${ellipsis}`
        : `${input.substring(0, (decoded.indexOf('<br />')))}${ellipsis}`
    );
  }

  if (decoded.includes('</p>')) {
    return (
      decoded.length > length
        ? `${decoded.substring(0, length - 1)}${ellipsis}`
        : `${input.substring(0, (decoded.indexOf('</p>')))}${ellipsis}`
    );
  }

  return (input.length > length) ? `${input.substring(0, length - 1)}${ellipsis}` : input;
};
